import { Link, SearchParams } from '@gogame/navigation';

import { screenSchema } from './schemas';

export const labelsSearchParams = new SearchParams(screenSchema);

export const labelsLink = new Link('labels', labelsSearchParams);
